/**
 * @generated SignedSource<<179b28453faa3c7f27975772434f5cab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkConversationReadInput = {
  conversationId: any;
};
export type useMarkConversationReadMutationMarkConversationReadMutation$variables = {
  input: MarkConversationReadInput;
};
export type useMarkConversationReadMutationMarkConversationReadMutation$data = {
  readonly markConversationRead: {
    readonly conversation: {
      readonly hasUnreadResponse: boolean;
      readonly id: any;
    } | null | undefined;
    readonly success: boolean;
  };
};
export type useMarkConversationReadMutationMarkConversationReadMutation = {
  response: useMarkConversationReadMutationMarkConversationReadMutation$data;
  variables: useMarkConversationReadMutationMarkConversationReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkConversationReadPayload",
    "kind": "LinkedField",
    "name": "markConversationRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnreadResponse",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMarkConversationReadMutationMarkConversationReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMarkConversationReadMutationMarkConversationReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0308df24427f3f77d2aa79c66155528",
    "id": null,
    "metadata": {},
    "name": "useMarkConversationReadMutationMarkConversationReadMutation",
    "operationKind": "mutation",
    "text": "mutation useMarkConversationReadMutationMarkConversationReadMutation(\n  $input: MarkConversationReadInput!\n) {\n  markConversationRead(input: $input) {\n    success\n    conversation {\n      id\n      hasUnreadResponse\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02569394eb0088a10ca49c0336933c64";

export default node;
